import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { MotionConfig } from 'framer-motion';
import { TrustBar } from './components/sections/TrustBar';
import { Hero } from './components/sections/Hero';
import { OfferBar } from './components/sections/OfferBar';
import { ProblemSection } from './components/sections/ProblemSection';
import { FamiliarSection } from './components/sections/FamiliarSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { ModulesSection } from './components/sections/ModulesSection';
import { SessionsSection } from './components/sections/SessionsSection';
import { ResourcesSection } from './components/sections/ResourcesSection';
import { BeforeAfterSection } from './components/sections/BeforeAfterSection';
import { AudienceSection } from './components/sections/AudienceSection';
import { BonusSection } from './components/sections/BonusSection';
import { ValueStackSection } from './components/sections/ValueStackSection';
import { PricingSection } from './components/sections/PricingSection';
import { SecuritySection } from './components/sections/SecuritySection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCta } from './components/sections/FinalCta';
import { PurchaseToast } from './components/PurchaseToast';
import { recentPurchases } from './data/recentPurchases';
import type { Purchase } from './types/purchase';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
type AppProps = {
  /** Solo para revisar el diseño del aviso: muestra un ejemplo genérico, no una compra real. */
  previewPurchaseToast?: boolean;
};
const PREVIEW_PURCHASE: Purchase[] = [{
  name: 'Nombre',
  city: 'Ciudad',
  province: 'Provincia'
}];
export function App({
  previewPurchaseToast = false
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  const purchases = recentPurchases.length > 0 ? recentPurchases : previewPurchaseToast ? PREVIEW_PURCHASE : [];
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="35ghusegjner">
      <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-1" data-mp="38b5essrpoce">
        <TrustBar data-id="element-2" data-mp="3uc9j1w993mja" />
        <Hero data-id="element-3" data-mp="3uevq7us8c00z" />
        <OfferBar data-id="element-4" data-mp="d4nwrk0ubq3z" />
        <main data-id="element-5" data-mp="d57h17dyqql6">
          <ProblemSection data-id="element-6" data-mp="d3mlpfjtr3m9" />
          <FamiliarSection data-id="element-7" data-mp="d45v27vesjoo" />
          <SolutionSection data-id="element-8" data-mp="d2bfl92wpjrz" />
          <ModulesSection data-id="element-9" data-mp="851hl51gbzsj" />
          <SessionsSection data-id="element-10" data-mp="86w3omoglxy7" />
          <ResourcesSection data-id="element-11" data-mp="83i6dsunkexm" />
          <BeforeAfterSection data-id="element-12" data-mp="3gl4q1d0e1shx" />
          <AudienceSection data-id="element-13" data-mp="3gm63tp8sgt3c" />
          <BonusSection data-id="element-14" data-mp="3gja7248ogagh" />
          <ValueStackSection data-id="element-15" data-mp="3bmbazg5gdtfn" />
          <TestimonialsSection data-id="element-16" data-mp="3bncpxvplb02n" />
          <PricingSection data-id="element-17" data-mp="3bo4kd37garrc" />
          <SecuritySection data-id="element-18" data-mp="3qb7klhn5reid" />
          <FaqSection data-id="element-19" data-mp="3qbfv52vt67qe" />
        </main>
        <FinalCta data-id="element-20" data-mp="3qcim1at4sa6b" />
        <PurchaseToast purchases={purchases} data-id="element-21" data-mp="3qd0t72hc08t0" />
      </div>
    </MotionConfig>;
}